import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/fonts.css';
import './design/tokens.css';
import './styles.css';
import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root-Element #root fehlt in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
